"use strict";

import angular from "angular";
import { sortGroupCompanies } from "../../../../utils/group-company-label";
import _ from "lodash";
import { Accounting } from "../../../../gateway/Accounting/Accounting";
import { LocalStoreService } from "../../../../presentation/services/LocalStoreService";
import { Company } from "../../../../gateway/Company/Company";
import { UserDataAdapter } from "../../../../presentation/adpters/UserDataAdapter";
import { Point } from "../../../../gateway/Point/Point";
import { PointCalculated } from "../../../../gateway/PointCalculated/PointCalculated";
import { PopulateManager } from "../../../../presentation/services/PopulateManager/PopulateManager";
import { Serie } from "../../../../gateway/Serie/Serie";
import { GroupOfCompaniesGateway } from "../../../../gateway/GroupOfCompanies/GroupOfCompaniesGateway";
import { DashboardAvailable } from "../../../../gateway/DashboardAvailable/DashboardAvailable";
import { AvailablePopulateUsecase } from "../../../../usecases/available-populate.usecase";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.reports", {
            url: "/meus-relatorios?report&feedbackIndex&feedbackType&scrollTo",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-reports" */ "../../company/reports/reports.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.company.reports"));
            },
            views: {
                "admin@nucont.accounting": {
                    component: "reportsListComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                report: null,
                feedbackIndex: null,
                feedbackType: null
            }
        })
        .state("nucont.reports.group", {
            url:
                "contabilidade/:accountingId/grupo/:id/relatorios?report&feedbackIndex&feedbackType&scrollTo&download&userIdentify&accIdReference&liveToken",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-reports" */ "../../company/reports/reports.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.company.reports"));
            },
            params: {
                accountingId: {
                    value: null
                },
                id: {
                    value: null
                },
                download: null,
                report: null,
                feedbackIndex: null,
                feedbackType: null,
                userIdentify: null,
                liveToken: null,
                user: null
            },
            views: {
                "main@": {
                    component: "emptyLayoutComponent"
                }
            },
            resolve: {
                accountingData: [
                    "$stateParams",
                    async ($stateParams) => {
                        const AccountingGetaway = new Accounting();
                        const accountingData = await AccountingGetaway.getById(
                            $stateParams.accountingId
                        );
                        const localStoreService = new LocalStoreService();
                        localStoreService.setItem("accounting", {
                            _id: accountingData?._id,
                            name: accountingData?.name,
                            plan: accountingData?.plan?.name,
                            contract: accountingData?.contract,
                            status: accountingData?.status,
                            createdAt: accountingData?.createdAt
                        });
                        console.log("accountingData", accountingData);
                        return accountingData;
                    }
                ],
                groupData: [
                    "$stateParams",
                    async ($stateParams) => {
                        const gateway = new GroupOfCompaniesGateway();
                        let group = await gateway.findById($stateParams.id);
                        group.companies = sortGroupCompanies(
                            await new Company().getByIds(group.companyIds)
                        );
                        group.isGroup = true;
                        const localStoreService = new LocalStoreService();
                        localStoreService.setItem("company", {
                            _id: group?._id,
                            name: group?.name,
                            segment: group?.segment?.t,
                            segmentGroup: group?.segmentGroup,
                            size: group?.size,
                            taxation: group?.taxation
                        });
                        console.log("group", group);
                        return group;
                    }
                ],
                user: [
                    "$stateParams",
                    async ($stateParams) => {
                        let user = {};
                        if ($stateParams.user) {
                            user = $stateParams.user;
                        } else {
                            user = new UserDataAdapter().user();
                        }
                        const localStorageService = new LocalStoreService();
                        localStorageService.setItem("user", user);
                        return user;
                    }
                ],
                AvailablePopulate: [
                    "$stateParams",
                    "groupData",
                    async ($stateParams, groupData) => {
                        new Point().deleteMany({});
                        new PointCalculated().deleteMany({});
                        new PopulateManager().deleteMany({});
                        new Serie().deleteMany({});
                        const dashboardAvailable = new DashboardAvailable();
                        const availablePopulateUsecase = new AvailablePopulateUsecase();
                        const groupId = $stateParams.id;
                        await availablePopulateUsecase.execute({ companyId: groupData.companyIds, groupId, groupStartDate: groupData.dateFrom });
                        await dashboardAvailable.populate({
                            companyId: groupId
                        });
                    }
                ]
            }
        })
        .state("nucont.reports.group.visualization", {
            url: "/dashboard/:reportId",
            params: {
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null,
                fromEmail: null
            },
            views: {
                "empty@nucont.reports.group": {
                    component: "reportsVisualizationComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.group.visualization",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.group.rules", {
            url: "/regras/:reportId",
            params: {
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null
            },
            views: {
                "empty@nucont.reports.group": {
                    component: "reportRulesComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.group.rules",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.group.dre", {
            url: "/dre/:reportId",
            params: {
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null
            },
            views: {
                "empty@nucont.reports.group": {
                    component: "reportsDreComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName: "nucont.reports.group.dre",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.group.dre.comparation", {
            url: "/comparacao",
            params: {},
            views: {
                "empty@nucont.reports.group": {
                    component: "reportsDreComparationComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.group.dre.comparation",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.group.balance", {
            url: "/balanco/:reportId",
            params: {
                reportId: null,
                generate: false,
                lastState: null,
                arrowRule: null
            },
            views: {
                "empty@nucont.reports.group": {
                    component: "reportBalanceComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.group.balance",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        })
        .state("nucont.reports.group.balance.comparation", {
            url: "/comparacao",
            params: {},
            views: {
                "empty@nucont.reports.group": {
                    component: "reportBalanceComparationComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                checkLogin: [
                    "$stateParams",
                    "$state",
                    "user",
                    async ($stateParams, $state, user) => {
                        if (!user) {
                            console.log("REPORT NO USER", $stateParams);
                            $state.go("nucont.authentication", {
                                redirectToStateName:
                                    "nucont.reports.group.balance.comparation",
                                redirectToStateParams: $stateParams
                            });
                            return false;
                        } else {
                            return true;
                        }
                    }
                ]
            },
            bodyClass: "report-visualization-module"
        });
}
